module.exports = __webpack_public_path__ + "img/566-42dfb3.png";